import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDepartmentAvailableColumns } from './api';

export const path = '/calculator-tariff/department/list';

const PageDepartmentList: React.FC = (props) => {
  const DepartmentList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDepartmentAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DepartmentList {...props} />;
};

export default PageDepartmentList;
